import React from 'react';
import { LeftNavMain, LeftNavFloat, LeftNavLink } from './LeftNav.style';
import useAppState from '../useAppState';


const LeftNav = (props) => {
  // const { state, actions } = useAppState();

  return (
    <LeftNavMain>
      <LeftNavFloat>
        <LeftNavLink onClick={() => props.actions.changeView('precio')}>Precio</LeftNavLink>
        <LeftNavLink onClick={() => props.actions.changeView('percepcion')}>Percepción</LeftNavLink>
        <LeftNavLink onClick={() => props.actions.changeView('tendencia')}>Tendencia</LeftNavLink>
        <LeftNavLink onClick={() => props.actions.changeView('competencia')}>Competencia</LeftNavLink>
      </LeftNavFloat>
    </LeftNavMain>
  );
}

export default LeftNav;
